export const setVisibleDimensions = () => {
  if (typeof window === 'undefined') return
  const heightVarName = 'visible-height'
  const widthVarName = 'visible-width'
  const set = () => {
    document.documentElement.style.setProperty(
      '--' + heightVarName,
      window.innerHeight + 'px',
    )
    document.documentElement.style.setProperty(
      '--' + widthVarName,
      window.innerWidth + 'px',
    )
  }
  set()
  window.addEventListener('resize', set)

  // Track visual viewport (responds to virtual keyboard on mobile).
  // Exposes --visual-viewport-height and --visual-viewport-offset-top so
  // fixed-position overlays can resize to sit above the virtual keyboard.
  const vv = window.visualViewport
  if (vv) {
    const setVV = () => {
      document.documentElement.style.setProperty(
        '--visual-viewport-height',
        `${vv.height}px`,
      )
      document.documentElement.style.setProperty(
        '--visual-viewport-offset-top',
        `${vv.offsetTop}px`,
      )
    }
    setVV()
    vv.addEventListener('resize', setVV)
    vv.addEventListener('scroll', setVV)
  }
}
